import React from "react";
import { Tooltip, TooltipProps } from "src/ui/shared/Tooltip";
import { makeStyles } from "tss-react/mui";

import { IconProps, MenuItem, MenuItemProps, Typography, TypographyProps, useTheme } from "@mui/material";

const useStyles = makeStyles()((theme) => ({
    menuItem: {
        height: "1.85rem",
        "&:hover": {
            backgroundColor: theme.palette.emteria.background.listHover,
        },
    },
    iconContainer: {
        width: 16,
        display: "inline-flex",
        justifyContent: "center",
        marginRight: theme.spacing(2),
    },
}));

interface DropdownItemProps extends MenuItemProps {
    label: string;
    button?: true;
    tooltipProps?: Omit<TooltipProps, "children">;
    iconProps?: Omit<IconProps, "children">;
    labelProps?: Omit<TypographyProps, "children">;
    iconName?: string;
}

export function DropdownItem({
    tooltipProps = { title: "", hide: true },
    iconName,
    iconProps,
    labelProps,
    label,
    ...props
}: DropdownItemProps): React.JSX.Element {
    const { classes } = useStyles();
    const theme = useTheme();

    return (
        <Tooltip {...tooltipProps}>
            <MenuItem className={classes.menuItem} {...props}>
                {iconName ? (
                    <div className={classes.iconContainer}>
                        <i className={iconName} style={{ color: theme.palette.emteria.text.primary }} {...iconProps} />
                    </div>
                ) : null}
                <Typography {...labelProps}>{label}</Typography>
            </MenuItem>
        </Tooltip>
    );
}
